import { IShoppingBagData } from "../../types/ShoppingBag";
import { Fragment } from "react";
import { Box } from "@mui/material";
import EmptyOrders from "components/EmptyOrders";
import SingleOrderCard from "./singleOrderCard";

type Props = {
  orders: IShoppingBagData[] | undefined
}

export default function OrderList({orders} : Props) {

  if (!orders || orders.length < 1) {
    return (<EmptyOrders />);
  }

  return (
    <>
      {orders
      .slice(0, 9)
      .map((pedido) => (
        <Fragment key={pedido.id}>
          <Box>
            <SingleOrderCard order={pedido} />
          </Box>
        </Fragment>
      ))}
    </>
  );
}